import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    annulationTransactionSaga,
    excelExportSaga,
    getConsultationTransactionsListSaga,
} from "./consultationTransactionsSaga";

export default function* consultationTransactionsWatcher() {
  yield takeLatest(
    ActionsTypes.GET_CONSULTATION_TRANSACTIONS_LIST,
    getConsultationTransactionsListSaga
  );
  yield takeLatest(
    ActionsTypes.ANNULATION_TRANSACTION,
    annulationTransactionSaga
  );
  yield takeLatest(ActionsTypes.GENERAL_EXCEL_EXPORT, excelExportSaga);
}
